import React from 'react'
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  PinterestShareButton,
  PinterestIcon,
} from 'react-share'

import Share from './Share.styled'

const ShareComponent = (props) => {
  const {
    url,
    media,
  } = props

  return (
    <Share>
      <span className='d-inline-block mr-2'>Share:</span>

      <Share.Btns>
        <FacebookShareButton url={url}>
          <FacebookIcon size={30} round />
        </FacebookShareButton>

        <LinkedinShareButton url={url}>
          <LinkedinIcon size={30} round />
        </LinkedinShareButton>

        <TwitterShareButton url={url}>
          <TwitterIcon size={30} round />
        </TwitterShareButton>

        <PinterestShareButton
          url={url}
          media={media}
        >
          <PinterestIcon size={30} round />
        </PinterestShareButton>
      </Share.Btns>
    </Share>
  )
}

export default ShareComponent
